import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable, Subscription } from 'rxjs';
import { ITask } from './ITask';
import { subscribeOn, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { LookupState, getTasksLookup } from './store/reducers';
import * as fromLookups from './store/actions';

@Injectable({
    providedIn: 'root'
})
export class TasksLookupService {
    uri = `${environment.apiLocation}/Task`;
    uriActiveOnly = `${this.uri}/ActiveOnly/false`;
    uriUserTasks = `${environment.apiLocation}/UserTask`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    public get(): Observable<Array<ITask>> {
        this.log.verbose({
            type: 'TasksLookupService:get',
            uri: this.uriActiveOnly
        });
        return this.http.get<Array<ITask>>(this.uriActiveOnly).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'TasksLookupService:reponse',
                    res
                })
            )
        );
    }

    public getUserTasks(
        ProcessID: number,
        AsOfDate: Date
    ): Observable<Array<ITask>> {
        this.log.verbose({ type: 'getUserTasks', ProcessID, AsOfDate });
        return this.http
            .post<Array<ITask>>(this.uriUserTasks, { ProcessID, AsOfDate })
            .pipe(
                tap(res =>
                    this.log.verbose({ type: 'getUserTasks:reponse', res })
                )
            );
    }
    public getContractTasks(contractlistid: string) {
        this.log.verbose({ type: 'getContractTasks', contractlistid, });
        return this.http
            .post<Array<ITask>>(this.uri, {
                contractlistid,
                roleGroupId: null,
                activeOnly: true
            })
            .pipe(
                tap(res =>
                    this.log.verbose({ type: 'getContractTasks:reponse', res })
                )
            );
    }
}
